<template>
  <Draw :mode=1 />
</template>

<script>
import Draw from './Draw.vue';

export default {
  components: {
    Draw
  },
  data: function() {
    return {
      
    }
  },
  mounted() {

  },
  methods: {
  }
}

</script>
